/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum InvestmentDetailsLegalDocumentSignerStatus {
    SIGNED = 'SIGNED',
    PENDING = 'PENDING',
}
